module.exports = __webpack_public_path__ + "img/code-bulk-img.67452c99.png";